import React from 'react'
import { Link } from 'react-router-dom'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { Box, Tooltip, IconButton } from '@mui/material'
import SummarizeIcon from '@mui/icons-material/Summarize'
import { useExportGmnPoints, useGetGmnPoints } from '../../api/gmn'
import { groupByProduct } from '../../utils/product'

export const GmnPointsPage = () => {
  // Wrap onto multiple lines instead of forcing wide columns.
  const wrapHeaderSx = { whiteSpace: 'normal', width: '72px' }

  const columns = [
    {
      id: 'companyName',
      label: 'Company Name',
    },
    {
      id: 'salesId',
      label: 'Sales Id',
      view: ({ pointBreakdown = [] }) => (
        <Box>
          {groupByProduct(pointBreakdown).map((e, i) => (
            <span key={i} style={{ display: 'block' }}>
              {e.companies?.[0]?.salesId}
            </span>
          ))}
        </Box>
      ),
    },
    {
      id: 'product',
      label: 'Product',
      view: ({ pointBreakdown = [] }) => (
        <Box>
          {groupByProduct(pointBreakdown).map((e, i) => (
            <span key={i} style={{ display: 'block' }}>
              {e.htgCompany}
            </span>
          ))}
        </Box>
      ),
    },
    {
      id: 'earned',
      label: 'Earned Points',
      headerSx: wrapHeaderSx,
      view: ({ pointBreakdown = [] }) => (
        <Box>
          {groupByProduct(pointBreakdown).map((e, i) => (
            <span key={i} style={{ display: 'block' }}>
              {e.points}
            </span>
          ))}
        </Box>
      ),
    },
    {
      id: 'totalPoints',
      label: 'Total Points',
      headerSx: wrapHeaderSx,
    },
    {
      id: 't1Tickets',
      label: 'Tier 1 Tickets',
      headerSx: wrapHeaderSx,
    },
    {
      id: 't2Tickets',
      label: 'Tier 2 Tickets',
      headerSx: wrapHeaderSx,
    },
    {
      id: 'bonusT2Tickets',
      label: 'Bonus Tier 2 Tickets',
      headerSx: wrapHeaderSx,
    },
    {
      id: 'multiProductTicket',
      label: 'Multi-Product Ticket',
      headerSx: wrapHeaderSx,
    },
    {
      id: 'actions',
      label: '',
      view: ({ mappingId }) => (
        <Link to={`/gmn/points/${mappingId}`}>
          <Tooltip title='View Summary'>
            <IconButton>
              <SummarizeIcon />
            </IconButton>
          </Tooltip>
        </Link>
      ),
    },
  ]

  return (
    <PointPanelScreen
      title='Golden Moon Night Points'
      useExportApi={useExportGmnPoints}
      useGetPoints={useGetGmnPoints}
      columns={columns}
      tableSx={{
        whiteSpace: 'nowrap',
        '& td': { verticalAlign: 'top' },
      }}
    />
  )
}
